declare global {
    interface Window {
        gtag?: (...args: any[]) => void;
    }
}

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_ID || '';

export const trackPageView = (page: string) => {
    if (!GA_MEASUREMENT_ID || !window.gtag) return;
    window.gtag('event', 'page_view', { page_path: page });
};

export const trackEvent = (
    category: string,
    action: string,
    label?: string
) => {
    if (!GA_MEASUREMENT_ID || !window.gtag) return;
    window.gtag('event', action, {
        event_category: category,
        event_label: label
    });
};
